import cn from 'classnames'
import React from 'react'
import { OpeningHoursFragment } from '../src/model/fragments'

export interface OpeningHoursProps {
	data: OpeningHoursFragment[]
	note?: React.ReactNode
}

const isGroupOptionSpecial = (
	group: OpeningHoursFragment['options'][number],
) => {
	if (group && group.title && (group.title.match(/\./g) || []).length >= 2) {
		return true
	}
	return false
}

export const OpeningHours: React.FunctionComponent<OpeningHoursProps> = ({
	data,
	note,
}) => {

	return (
		<section className="openingHours">
			{note && <div className="openingHours-note">{note}</div>}
			{data.map((group, i) => (
				<div className={'openingHours-group'} key={i}>
					<div className="openingHours-group-title">{group.title}</div>
					<div className="openingHours-group-value">{group.value}</div>
					{group.options.length > 0 && (
						<div className={'openingHours-options'}>
							{group.options.map((option, i) => (
								<div
									className={cn(
										'openingHours-option',
										isGroupOptionSpecial(option) && 'view-special',
									)}
									key={i}
								>
									<div className="openingHours-option-title">
										{option.title}
									</div>
									<div className="openingHours-option-value">
										{option.value}
									</div>
								</div>
							))}
						</div>
					)}
				</div>
			))}
		</section>
	)
}
